/* eslint-env jest */
import giftAddonVisible from './giftAddonVisible';

const addon = ({ cssName = 'mug', isSenior = false, isElementary = false } = {}) => (
  {
    cssName, isSenior, isElementary, _attributes: { cssName },
  }
);

describe('giftAddonVisible - the paid magnet tile under the free-magnets offer', () => {
  const magnet = addon({ cssName: 'magnet' });
  it('hides the paid magnets only when the cart already holds the free pair', () => {
    expect(giftAddonVisible(magnet, { hasFreeMagnets: true })).toBe(false);
  });
  it('keeps them purchasable when the pair was never granted (all-JPG or declined)', () => {
    expect(giftAddonVisible(magnet, { hasFreeMagnets: false })).toBe(true);
  });
  it('never hides the magnet calendar (different product)', () => {
    expect(giftAddonVisible(addon({ cssName: 'calendar' }), { hasFreeMagnets: true })).toBe(true);
  });
});

describe('giftAddonVisible - pre-existing rules preserved', () => {
  it('hides sibling tiles', () => {
    expect(giftAddonVisible(addon({ cssName: 'sibling' }))).toBe(false);
  });
  it('grad tiles are senior-only', () => {
    expect(giftAddonVisible(addon({ cssName: 'grad-announce' }), { seniorCustomer: true })).toBe(true);
    expect(giftAddonVisible(addon({ cssName: 'grad-announce' }), { seniorCustomer: false })).toBe(false);
  });
  it('audience-priced rows go to their audience', () => {
    expect(giftAddonVisible(addon({ isSenior: true }), { seniorCustomer: false })).toBe(false);
    expect(giftAddonVisible(addon({ isElementary: true }), { seniorCustomer: false })).toBe(true);
  });
});
